import axiosInstance from '../utils/axios.config';
import { Message } from '../types/context';

class ApiService {
  async sendMessage(endpoint:string,prompt:{}): Promise<Message> {

    try {
      const { data } = await axiosInstance.post(endpoint, prompt );
      if (endpoint === '/sales') {
        return {
          role: 'ai',
          text: data.response_text,
        };
      }
      return {
        role: 'ai',
        text: data.assistant_message.response_text,
      };
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async fetchHistory(userId: string, username?:string): Promise<Message[]> {
    try {
      if (userId === 'sales') {
        const { data } = await axiosInstance.post<Message[]>(`chat/history?user_id=${userId}`);
      return data;
      }
      const { data } = await axiosInstance.post<Message[]>(`chat/history?user_id=${userId}&user_name=${username}`);
      return data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  private handleError(error: any): Error {
    if (error.response) {
      throw new Error(error.response.data.message || 'An error occurred');
    }
    throw new Error('Network error occurred');
  }
}

const apiService = new ApiService();

export default apiService;